// extracted by mini-css-extract-plugin
module.exports = {"view":"PrivacyPolicy_view__2I-Vu","policy":"PrivacyPolicy_policy__1tzMl"};